const initialState = {
  userDetail: null,
  registerUser: {},
  mobileNumber: "",
  showAccountActivated: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "USER_DETAIL":
      return {
        ...state,
        userDetail: { ...payload },
      };
    case "REGISTER_USER":
      return {
        ...state,
        registerUser: { ...payload },
      };
    case "MOBILE_NUMBER_LOGIN":
      return {
        ...state,
        mobileNumber: payload,
      };
    case "GET_USER_PROFILE_DATA":
      return {
        ...state,
        userData: payload,
      };

    case "SHOW_ACCOUNT_ACTIVATED":
      return {
        ...state,
        showAccountActivated: payload,
      };
    default:
      return state;
  }
};
